import { render, staticRenderFns } from "./add-dialog.vue?vue&type=template&id=2d26ad73"
import script from "./add-dialog.vue?vue&type=script&lang=js"
export * from "./add-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports